export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/wallet.worker.c231290d7a23844b1c0f.worker.js");
}
